import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import Interpret from "../../components/shared/Localization/Interpret";
import { E_BoxRoute_Action, E_Route } from "../../models/constants/Enum_Routes";
import BoxTerminal from "../../components/shared/BoxTerminal";
import ButtonsConstructor from "../../components/shared/Input/Button/ButtonsConstructor";
import { E_Configuration_DisplayMode } from "../../models/Models_Configuration";
import withConfiguration from "../../components/shared/hoc/withConfiguration";

class BoxOpeningPage extends Component {
	constructor(props) {
		super();

		this.state = {
			timeout: props.timeout,
		}
	}

	componentDidMount() {
		if(this.props.timeout > 0) {
			this._interval = setInterval(() => {
				this.setState(state => {
					let timeout = state.timeout - 1

					if(timeout < 1) {
						clearInterval(this._interval);
					}

					return {timeout}
				});
			}, 1000);
		}
	}

	componentWillUnmount() {
		clearInterval(this._interval);
	}

	render({className, style, boxAction, physicalReference}, {timeout}) {
		const isOpened = timeout < 1;

		return (
			<section className={combineClasses("box-opening-page", className)} style={style}>
				<BoxTerminal
					title={this._getTitle(boxAction)}
					contentHeaderSlot={
						<h2><Interpret id={isOpened ? "box.opened.farewell" : "box.open.pending"}/></h2>
					}
					contentHeaderRightSlot={
						<div className={"box-id"}>
							<Interpret id={"box.physicalReference"}/>

							<div className={"value"}>{physicalReference}</div>
						</div>
					}
					contentSlot={
						<div className={"content-message"}>
							{
								isOpened &&
								<div style={{margin: "auto"}}>
									{
										[E_BoxRoute_Action.OPEN, E_BoxRoute_Action.FIRST_OPENING].includes(boxAction) &&
										<>
											<h1><Interpret id={"pin.remember.hint"}/></h1>
											<h2><Interpret id={[E_BoxRoute_Action.OPEN, E_BoxRoute_Action.FIRST_OPENING].includes(boxAction) ? "box.open.repeated.explanation" : "box.open.end.explanation"}/></h2>
											<p><Interpret id={"usbSocket.hint"}/></p>
										</>
										||
										<>
											<h1><Interpret id={"box.open.end.explanation"}/></h1>
										</>
									}
								</div>
								||
								<>
									<h1>
										<Interpret id={"box.open.pending.inNSeconds"} params={{timeout}}/>
									</h1>

									<h2 className={"addendum"}>
										<Interpret id={"box.open.pending.addendum"}/>
									</h2>
								</>
							}
						</div>
					}
					helperSlot={
						<>
							<p style={{marginBottom: "1rem"}}><Interpret id={"box.open.error.help.message"}/></p>

							<ButtonsConstructor buttons={[
								{
									text: "support.contact",
									className: "contact-support",
									href: E_Route.HELP,
								}
							]}/>
						</>
					}
					contentRightSlot={
						isOpened &&
						<ButtonsConstructor
							buttons={[
								{
									className: "ok",
									text: "ok",
									href: E_Route.BASE,
								}
							]}
						/>
					}
				/>
			</section>
		);
	}

	_getTitle(boxAction) {
		switch (boxAction) {
			case E_BoxRoute_Action.FIRST_OPENING:
				return "box.open.firstTime"
			case E_BoxRoute_Action.OPEN:
				return "box.open.repeated";
			case E_BoxRoute_Action.RETRIEVE:
				if(this.props.configuration.mode === E_Configuration_DisplayMode.DELIVERY) {
					return "box.open.end.delivery.title";
				}
				return "box.open.end";
		}
	}

	static get sharedTypes() {
		return {
			timeout: PropTypes.number,
		}
	}

	static get propTypes() {
		return {
			...BoxOpeningPage.sharedTypes,
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			boxAction: PropTypes.oneOf(Object.values(E_BoxRoute_Action)),
			physicalReference: PropTypes.string,

			//withConfiguration
			configuration: PropTypes.object,
		}
	}

	static get stateTypes() {
		return {
			...BoxOpeningPage.sharedTypes,
		}
	}

	static get defaultProps() {
		return {
			timeout: 1,
			boxAction: E_BoxRoute_Action.OPEN,
			physicalReference: "N/A",
		}
	}
}

export default withConfiguration(BoxOpeningPage);
